import { z } from 'zod';

export default z.object({
  id: z.number(),
  countryId: z.string(),
  name: z.string(),
  demonym: z.string(),
  siteUrl: z.string(),
  contact: z.object({ contactInfo: z.string(), contactMethod: z.string() }),
  facebook: z.string(),
  instagram: z.string(),
  brand: z.string(),
  exampleBatch: z.string(),
  daysForDistribution: z.number(),
  theme: z.object({
    navColor: z.string(),
    accentColor: z.string(),
    accentColor2: z.string(),
    secondaryColor: z.string(),
    iconColor: z.string(),
    logoHeigth: z.string(),
    logoWidth: z.string(),
    logoMinHeigth: z.string(),
    logoMinWidth: z.string(),
  }),
});
